import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { CheckboxFieldComponent } from '../checkbox-field/checkbox-field.component';

export type RmsFilterType = 'text' | 'select' | 'date' | 'number' | 'checkbox';

export interface RmsFilterOption {
  key: string;
  label?: string;
  type?: RmsFilterType;
  options?: Array<{ label: string; value: any }>;
  defaultValue?: any;
}

export interface RmsSavedFilter {
  id: string;
  name: string;
  values: Record<string, any>;
  createdUtc: string;
}

@Component({
  selector: 'rms-filter-bar',
  standalone: true,
  imports: [MatIconModule, MatMenuModule, MatButtonModule, FormsModule, CheckboxFieldComponent],
  templateUrl: './rms-filter-bar.component.html',
  styleUrls: ['./rms-filter-bar.component.scss']
})
export class RmsFilterBarComponent implements OnChanges {
  @Input() filters: RmsFilterOption[] = [];
  @Input() values: Record<string, any> | null = null;
  @Input() saved: RmsSavedFilter[] = [];
  @Input() enableSaving = true;

  @Output() apply = new EventEmitter<Record<string, any>>();
  @Output() clear = new EventEmitter<void>();
  @Output() save = new EventEmitter<string>();          // emits name
  @Output() load = new EventEmitter<string>();          // emits saved id
  @Output() delete = new EventEmitter<string>();        // emits saved id
  @Output() change = new EventEmitter<Record<string, any>>(); // on every keystroke/change

  model: Record<string, any> = {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filters'] || changes['values']) {
      const base: Record<string, any> = {};
      for (const f of this.filters ?? []) base[f.key] = f.defaultValue ?? '';
      this.model = { ...base, ...(this.values ?? {}) };
    }
  }

  onApply() {
    this.apply.emit({ ...this.model });
  }

  onClear() {
    const base: Record<string, any> = {};
    for (const f of this.filters ?? []) base[f.key] = f.defaultValue ?? '';
    this.model = base;
    this.clear.emit();
    this.change.emit({ ...this.model });
  }

  onFieldChange() {
    this.change.emit({ ...this.model });
  }
}
